<template>
  <div class="systemCodeParametersList">
    <el-card class="location">
      <div class="divL">
        <el-button type="primary" @click="addModule">{{$t('lang.btn_addModule')}}</el-button>
        <el-button type="primary" @click="addCode">{{$t('lang.btn_addCode')}}</el-button>
        <el-button type="primary" @click="deleteNow">{{$t('lang.btn_deleteNow')}}</el-button>
        <el-form :label-suffix="require('@/config/enum').c_colon" class="form-padding">
          <el-form-item :label="$t('lang.lab_keyword')">
            <el-input
              class="inputkey"
              :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_keyword')"
              v-model="filterText">
            </el-input> 
          </el-form-item>
        </el-form>
        <el-tree 
          class="filter-tree"
          ref="tree"
          :data="treeData" 
          :props="defaultProps"
          :filter-node-method="filterNode"
          node-key="id"
          @node-click="handleNodeClick"></el-tree>
      </div>
      <div class="divR">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-width="require('@/config/enum').c_w4" :label-suffix="require('@/config/enum').c_colon">
          <el-row v-show="this.isShowModuleFlag">
            <el-col :span = '8'>
              <el-form-item :label="$t('lang.lab_moduleName')" prop="moduleName">
                  <el-input v-model="ruleForm.moduleName" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_moduleName')" :disabled="this.isModuleDisabledFlag" maxlength="50"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span = '8'>
              <el-form-item :label="$t('lang.lab_moduleCode')" prop="moduleCode">
                  <el-input v-model="ruleForm.moduleCode" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_moduleCode')" :disabled="this.isModuleDisabledFlag" maxlength="50"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span = '8'>
              <el-form-item>
                <el-button type="primary" @click="saveModule('ruleForm')" v-show="this.isModuleDisabledFlag === false">{{$t('lang.btn_save')}}</el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="this.isShowCodeFlag">
            <el-col :span = '8'>
              <el-form-item :label="$t('lang.lab_theCodeName')" prop="codeName">
                  <el-input v-model="ruleForm.codeName" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_theCodeName')" :disabled="this.isCodeDisabledFlag" maxlength="50"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span = '8'>
              <el-form-item :label="$t('lang.lab_codeCode')" prop="codeCode">
                  <el-input v-model="ruleForm.codeCode" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_codeCode')" :disabled="this.isCodeDisabledFlag" maxlength="50"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span = '8'>
              <el-form-item>
                <el-button type="primary" @click="saveCode('ruleForm')" v-show="this.isCodeDisabledFlag === false">{{$t('lang.btn_save')}}</el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <el-table :data="tableData" border class="table-width" v-if="this.isShowOptionFlag">
            <el-table-column prop="optionCode" :label="$t('lang.lab_optionCode')" align="center" class="table-width">
              <template slot-scope="scope">
                <template v-if="scope.row.isNow">
                  <el-input v-model="scope.row.optionCode" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_optionCode')" maxlength="50"></el-input>
                </template>  
                <template v-else>
                  <span >{{ scope.row.optionCode }}</span>
                </template>
              </template>            
            </el-table-column>
            <el-table-column prop="optionValue" :label="$t('lang.lab_optionValue')" align="center" class="table-width">
              <template slot-scope="scope">
                <template v-if="scope.row.isNow">
                  <el-input v-model="scope.row.optionValue" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_optionCode')" maxlength="200"></el-input>
                </template>  
                <template v-else>
                  <span >{{ scope.row.optionValue }}</span>
                </template>
              </template>  
            </el-table-column>
            <el-table-column align="center" class="table-width">
              <template slot="header" slot-scope="scope">
                <el-button icon="el-icon-plus" @click="addOption(scope.row)"></el-button>
              </template>
              <template slot-scope="scope">
                <template v-if="scope.row.isNow">
                  <el-button icon="el-icon-check" @click="addOne(scope.row)"></el-button>
                </template>  
                <template v-else>
                  <el-button icon="el-icon-close" @click="deleteOne(scope.row)"></el-button>
                </template>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:systemCodeParametersList
 *@Description:系统代码参数
 *@author:宋莎
 *@Copyright:格众科技
 *@date:2020-03-30
 */
export default {
  data() {
    return {
      tableData: [], // 右侧选项表格数据optionlist
      treeData: [], // 获取treelist
      ruleForm: {
        moduleId: '', // 模块Id
        moduleName: '', // 模块名称
        moduleCode: '', // 模块编码
        codeId: '', // 当前id
        codeName: '', // 代码名称
        codeCode: '', // 代码编码
      }, // 右侧内容
      filterText: '', // 关键词检索
      data: '', // 保存当前节点数据
      level: 0, // 当前节点level
      isModuleDisabledFlag: true, // 模块输入框是否可点击：true-置灰不可点击
      isCodeDisabledFlag: true, // 代码输入框是否可点击：true-置灰不可点击
      isShowModuleFlag: false, // 模块行显示：true-显示
      isShowCodeFlag: false, // 代码行显示：true-显示
      isShowOptionFlag: false, // tableData显示：true-显示
      defaultProps: {
        children: 'children',
        label: 'name',
      }, // tree数据
      rules: {
        moduleName: [{ required: true, message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_moduleName'), trigger: 'blur' }],
        moduleCode: [{ required: true, message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_moduleCode'), trigger: 'blur' }],
        codeName: [{ required: true, message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_theCodeName'), trigger: 'blur' }],
        codeCode: [{ required: true, message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_codeCode'), trigger: 'blur' }],
      },
    }
  },
  created() {
    this.getData()
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    },
  },
  methods: {
    // 获取表格数据
    getData() {
      let loading = this.$loading()
      this.$get(`/getSysCodeList`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.treeData = res.result
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 初始化显示
    initShow() {
      this.isModuleDisabledFlag = true
      this.isCodeDisabledFlag = true
      this.isShowModuleFlag = false
      this.isShowCodeFlag = false
      this.isShowOptionFlag = false
      this.level = 0
    },
    // 添加模块
    addModule() {
      this.$refs.ruleForm.clearValidate()
      // 设置显示
      this.ruleForm.moduleName = ''
      this.ruleForm.moduleCode = ''
      this.isModuleDisabledFlag = false
      this.isCodeDisabledFlag = true
      this.isShowModuleFlag = true
      this.isShowCodeFlag = false
      this.isShowOptionFlag = false
    },
    // 添加常用代码
    addCode() {
      // 请选择一个模块！
      if (this.level != 1) {
        this.$message.error(this.$i18n.t('lang.lab_selectModule'))
        return
      }
      this.$refs.ruleForm.clearValidate()
      // 设置显示
      this.ruleForm.moduleId = this.data.id
      this.ruleForm.codeName = ''
      this.ruleForm.codeCode = ''
      this.isModuleDisabledFlag = true
      this.isCodeDisabledFlag = false
      this.isShowModuleFlag = true
      this.isShowCodeFlag = true
      this.isShowOptionFlag = false
    },
    // 保存模块            
    saveModule(formName) {
      let params = { }
      params.sysName = this.ruleForm.moduleName
      params.sysCode = this.ruleForm.moduleCode

      this.$refs[formName].validate((valid) => {
        if (valid) {
          let loading = this.$loading()
          this.$post('/saveModule', params).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_add_success'))
                // 更新界面
                this.initShow()
                this.getServerInfo()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        } else {
          return false
        }
      })
    },
    // 保存代码
    saveCode(formName) {
      let params = { }
      params.parentId = this.ruleForm.moduleId
      params.sysName = this.ruleForm.codeName
      params.sysCode = this.ruleForm.codeCode

      this.$refs[formName].validate((valid) => {
        if (valid) {
          let loading = this.$loading()
          this.$post('/saveCode', params).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_add_success'))
                // 更新界面
                this.initShow()
                this.getServerInfo()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        } else {
          return false
        }
      })
    },
    // 更新服务器内容
    getServerInfo() {
      let loading = this.$loading()
      this.$get(`/getServerInfo`).then(
        res => {
          loading.close()
          if (res) {
            console.log('getServerInfo', res)
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
      this.getData()
    },
    // 添加选项值
    addOption(data) {
      // 请先完成上次添加操作！
      if (this.tableData.length != 0 && !this.tableData[this.tableData.length - 1].optionId) {
          this.$message.error(this.$i18n.t('lang.lab_needFinishLastAdd'))
          return
      }
      // 新填行显示
      var newValue = {
        optionCode: '',
        optionValue: '',
        isNow: true, 
      }
      // 添加新的行数
      this.tableData.push(newValue)
    },
    // 删除选项值
    deleteOne(data) {
      let params = {
        optionId: data.optionId 
      }
      let loading = this.$loading()
      this.$confirm(
        this.$i18n.t('lang.lab_isdelete'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          this.$patch(`/deleteSystemOption`, params).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_del_success')
                })
                // 更新tableData
                this.updataTableData(res.result)
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )   
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can')
          })
        })      
    },
    // 添加选项值
    addOne(data) {
      // 选项代码或选项值未填写，保存不成功
      if (data.optionCode.trim() === '' || data.optionValue.trim() === '') {
        this.tableData = this.tableData.splice(0, this.tableData.length - 1)
        return
      }
      let params = { }
      params.codeId = this.ruleForm.codeId
      params.optionCode = data.optionCode
      params.optionValue = data.optionValue

      let loading = this.$loading()
      this.$post('/submitSystemOption', params).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.$message.success(this.$i18n.t('lang.lab_add_success'))
            // 更新tableData
            data.isNow = false
            this.updataTableData(res.result)
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )      
    },
    // 根据id找数组
    findIndex(data, id) {
      return data.findIndex(item => item.id === id)
    },
    // 更新tableData
    updataTableData(data) {
      let tempdata = data[this.findIndex(data, this.ruleForm.moduleId)]
      this.tableData = tempdata.children[this.findIndex(tempdata.children, this.ruleForm.codeId)].optionList
    },
    // 删除当前选项
    deleteNow() {
      // 请选择一个选项！
      if (!(this.level === 1 || this.level === 2)) {
        this.$message.error(this.$i18n.t('lang.lab_selectCode'))
        return
      }
      // 当前模块下有常用代码，请先删除常用代码！
      if (this.data.children != null && this.data.children.length > 0) {
        this.$message.error(this.$i18n.t('lang.lab_theModuleHaveChildren'))
        return       
      }

      let loading = this.$loading()
      this.$confirm(this.$i18n.t('lang.lab_isdelete'), this.$i18n.t('lang.lab_prompt'), {
        confirmButtonText: this.$i18n.t('lang.btn_confirm'),
        cancelButtonText: this.$i18n.t('lang.btn_cancel'),
        type: 'warning'
      }).then(() => {
        let params = {
          codeId: this.ruleForm.codeId     
        }
        this.$patch(`/delCode`, params).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.$message({
                type: 'success',
                message: this.$i18n.t('lang.lab_del_success')
              })
              // 更新界面
              this.initShow()
              this.getServerInfo()
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
        })
      .catch(() => {
        loading.close()
        this.$message({
          type: 'info',
          message: this.$i18n.t('lang.lab_del_can')
        })
      })
    },
    // 点击tree节点
    handleNodeClick(data) {
      this.$refs.ruleForm.clearValidate()

      // 保存当前节点数据
      this.data = data
      // 获取当前节点node
      let node = this.$refs.tree.getNode(data)
      // 获取当前tree level
      this.level = node.level

      if (this.level === 2) {
        // 详细信息显示设置
        this.isModuleDisabledFlag = true
        this.isCodeDisabledFlag = true
        this.isShowModuleFlag = true
        this.isShowCodeFlag = true
        this.isShowOptionFlag = true
        // 获取当前树节点和其父级节点信息
        this.ruleForm.codeId = this.data.id
        this.ruleForm.moduleId = node.parent.data.id
        this.ruleForm.moduleName = node.parent.data.name
        this.ruleForm.moduleCode = node.parent.data.code       
        this.ruleForm.codeName = this.data.name
        this.ruleForm.codeCode = this.data.code
        this.tableData = this.data.optionList
      } else if (this.level === 1) {
        // 详细信息显示设置
        this.isModuleDisabledFlag = true
        this.isCodeDisabledFlag = true
        this.isShowModuleFlag = false
        this.isShowCodeFlag = false
        this.isShowOptionFlag = false
        // 获取当前节点信息
        this.ruleForm.codeId = this.data.id
        this.ruleForm.moduleName = this.data.name
        this.ruleForm.moduleCode = this.data.code    
      }
    }, 
    // 关键字
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) != -1
    }
  }
}
</script>

<style lang='scss'>
.systemCodeParametersList {
  .location{
    padding: 40px;
  }
  .form-padding{
    padding-top: 20px;
  }
  .divL{
    width: 40%;
    float: left;
  }
  .divR{
    width: 60%;
    float: right;
  }
  .inputkey{
    width: 60%;
  }
  .table-width{
    width: 100%
  }
}
</style>